// extracted by mini-css-extract-plugin
export default {"reportView":"ReportViewPage_reportView__R8wa5"};